import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import Box from "../../../../common/box/Box";
import CollapsibleBox from "../../../../common/collapsible/CollapsibleBox";
import Divider from "../../../../common/divider/Divider";
import { RequestSubmissionContext } from "../RequestSubmissionContext";
import RequiredDocumentInfoItem from "./RequiredDocumentInfoItem";

function Info() {
  const { state } = useContext(RequestSubmissionContext);
  const { t } = useTranslation();

  return (
    <div className="section">
      <Divider label={t("requests.submission.info.general")} />
      {state.info.messages.map((info, index) => (
        <CollapsibleBox className="pl-5" title={info.label} key={`collapsible${index}`}>
          <span className="is-size-6" dangerouslySetInnerHTML={{__html: `${info.content}`}}></span>
        </CollapsibleBox>
      ))}
      <Divider label={t("requests.submission.info.form")} />
      <Box>{state.pdfForm.name}</Box>
      <Divider label={t("requests.submission.info.attachments")} />
      {state.upload.documents.map(
        (doc, index) =>
          doc.required && (
            <RequiredDocumentInfoItem
              key={`doc${index}`}
              label={`${index + 1}. ${doc.label}`}
              link={doc.link}
            />
          )
      )}
    </div>
  );
}

export default Info;
